import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSectionInfo, selectCommon } from '../../../store/common';
import SideDrawer from '../../shared/side-drawer';
import EventsInfo from '../section-info/events';
import MentorsInfo from '../section-info/mentors';

const SectionInfoSideDrawer = () => {
  const { sectionInfo } = useSelector(selectCommon);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(addSectionInfo({ sectionInfo: undefined }));
  };

  return (
    <SideDrawer toggleDrawer={!!sectionInfo} onClose={onClose}>
      {sectionInfo === 'events' && <EventsInfo />}
      {sectionInfo === 'mentors' && <MentorsInfo />}
    </SideDrawer>
  );
};

export default SectionInfoSideDrawer;
